import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Dialog, DialogTitle } from '@material-ui/core';
import { Button, Select } from '@ipc/ipc-components';
import React, { useEffect, useState } from 'react';
import { AddHandlerDialogStyle } from '../component/AddHandlerDialog.styles';
import { getActiveMrdList } from '../../redux/selectors/DeviceInformationSelectors';
import { getActiveMrdListRequestActionCreator } from '../../redux/actions/DeviceInformationActions';

function CopyHandlerSettingsDialog(props) {
  const {
    openDialog,
    closeDialog,
    activeMrdList,
    selectedImpc,
    onSubmit,
    fetchActiveMrdList,
    addedMrdName,
  } = props;

  const [selectedMrd, setSelectedMrd] = useState(null);

  const handleOnClose = () => {
    setSelectedMrd(null);
    closeDialog();
  };

  const confirmSave = async () => {
    onSubmit(selectedMrd.label);
    handleOnClose();
  };

  const mrdOptions = activeMrdList.filter((mrd) => mrd.impc === selectedImpc && mrd.mrdName !== addedMrdName).map((el) => ({
    label: el.mrdName,
    value: el.mrdName,
  }));

  const handleOnChange = (selected) => {
    setSelectedMrd(selected);
  };

  useEffect(() => {
    if (openDialog) fetchActiveMrdList();
  }, [openDialog]);

  return (
    <Dialog onClose={closeDialog} aria-labelledby="simple-dialog-title" open={openDialog}>
      <AddHandlerDialogStyle>
        <DialogTitle id="simple-dialog-title">Copy handler settings from other MRD</DialogTitle>
        <div className="associate-handler-add-handler-body">
          <div className="form-input-fields">
            <Select
              options={mrdOptions}
              onChange={handleOnChange}
            />
          </div>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleOnClose} id="cancel">Cancel</Button>
          <Button
            onClick={confirmSave}
            className={`primary-button-${selectedMrd === null} after-box-submit`}
            disabled={selectedMrd === null}
            id="submit"
          >
            Submit
          </Button>
        </div>
      </AddHandlerDialogStyle>
    </Dialog>
  );
}

CopyHandlerSettingsDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.bool,
  onSubmit: PropTypes.func,
  activeMrdList: PropTypes.arrayOf(PropTypes.object),
  selectedImpc: PropTypes.string,
  fetchActiveMrdList: PropTypes.func,
  addedMrdName: PropTypes.string,
};

CopyHandlerSettingsDialog.defaultProps = {
  activeMrdList: [],
};

function mapStateToProps(state) {
  return {
    activeMrdList: getActiveMrdList(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  fetchActiveMrdList: getActiveMrdListRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CopyHandlerSettingsDialog);
